<!--
    This component maps a "value" object from the API DTO
-->
<template>
  <div class="d-flex">
    <md-field v-for="index in attrs" :key="index">
      <md-input size="4" v-model="value[index]" />
      <span v-if="units" class="md-suffix">{{
        typeof units == "string" ? units : units[index]
      }}</span>
    </md-field>
  </div>
</template>

<script>
export default {
  name: "TargetTableTuple",
  props: {
    value: Object,
    // units can be an string, which means all the tuple use the same units
    // or an object index based unit
    units: {
      type: [String, Object],
      default: null
    },
    attrs: Array
  }
};
</script>

<style scoped>
.d-flex .md-field {
  margin-right: 15px;
}
</style>
